import { LocationRouteType } from '@fcom/core-api';
import { FinnairCabinClass, TranslatedBenefitRow } from '@fcom/dapi/api/models';

export const BENEFITS_ICON_MAP = {
  checkedBaggage: 'checked-baggage',
  cabinBaggage: 'carry-on-bag',
  seatSelection: 'seat-or-economy',
  rebook: 'mmb-ticket-changes',
  cancel: 'ticket-refund',
  nameChange: 'single-pax',
  plusPoints: 'finnair-plus',
  loungeAccess: 'lounge',
  prioritySecurity: 'priority-security',
  priorityCheckIn: 'check-in',
  wifiAccess: 'wifi',
  cabinBaggageWithWeight: 'carry-on-baggage',
  cabinBagWithAmount: 'carry-on-bag-trolley',
  smallBag: 'backpack',
  carryOnBag: 'baggage',
  checkedBaggageWithAmountAndWeightSingular: 'checked-baggage',
  checkedBaggageWithAmountAndWeightPlural: 'checked-baggage',
  checkedBaggageWithWeight: 'checked-baggage',
};

export const BENEFITS = {
  checkedBaggage: 'checkedBaggage',
  cabinBaggage: 'cabinBaggage',
  seatSelection: 'seatSelection',
  rebook: 'rebook',
  cancel: 'cancel',
  nameChange: 'nameChange',
  plusPoints: 'plusPoints',
  loungeAccess: 'loungeAccess',
  prioritySecurity: 'prioritySecurity',
  priorityCheckIn: 'priorityCheckIn',
  wifiAccess: 'wifiAccess',
};

export const koreanColoredBenefits: (keyof typeof BENEFITS_ICON_MAP)[] = ['rebook', 'cancel'];

export const shouldDisplayBenefit = (benefit: TranslatedBenefitRow): boolean => {
  return (
    (benefit.isPositive && benefit.key !== BENEFITS.plusPoints && benefit.key !== BENEFITS.nameChange) ||
    benefit.key === BENEFITS.cancel ||
    benefit.key === BENEFITS.rebook
  );
};

const economyChanges = {
  shortHaul: {
    [LocationRouteType.DEFAULT]: [],
    [LocationRouteType.AJB]: [],
    [LocationRouteType.SJB]: [],
  },
  longHaul: {
    [LocationRouteType.DEFAULT]: [],
    [LocationRouteType.AJB]: [],
    [LocationRouteType.SJB]: [],
  },
};

export const CHANGED_BENEFITS_BY_CLASS = {
  [FinnairCabinClass.BUSINESS]: {
    shortHaul: {
      [LocationRouteType.DEFAULT]: [
        'cabinBaggageWithWeight',
        'smallBag',
        'cabinBagWithAmount',
        'checkedBaggageWithAmountAndWeightSingular',
        'checkedBaggageWithAmountAndWeightPlural',
      ],
      [LocationRouteType.AJB]: [],
      [LocationRouteType.SJB]: [],
    },
    longHaul: {
      [LocationRouteType.DEFAULT]: [
        'cabinBaggageWithWeight',
        'smallBag',
        'cabinBagWithAmount',
        'checkedBaggageWithAmountAndWeightSingular',
        'checkedBaggageWithAmountAndWeightPlural',
      ],
      [LocationRouteType.AJB]: ['cabinBaggageWithWeight', 'smallBag', 'cabinBagWithAmount'],
      [LocationRouteType.SJB]: ['cabinBaggageWithWeight', 'smallBag', 'cabinBagWithAmount'],
    },
  },
  [FinnairCabinClass.ECONOMY]: economyChanges,
  [FinnairCabinClass.ECOPREMIUM]: economyChanges,
  [FinnairCabinClass.FIRST]: economyChanges,
};
